import { CanvasApiBaseResponse } from '../../common/requestsTypings';
import { SharedData } from '../../common/typings';
import { CanvasApiMethodExecutor } from '../CanvasApiMethodExecutor';

export class CreativesApiMethodExecutor extends CanvasApiMethodExecutor {
    constructor(private readonly updatePath: string, apiPath?: string) {
        super(apiPath);
    }

    async update(id: string, newName: string, sharedData: SharedData) {
        return await this.createRequest<CanvasApiBaseResponse>(
            `${this.updatePath}/${id}`,
            {
                method: 'PATCH',
                body: JSON.stringify({
                    name: newName
                })
            },
            sharedData
        );
    }

    async delete(id: string, sharedData: SharedData) {
        return await this.createRequest<CanvasApiBaseResponse>(
            `${this.updatePath}/${id}`,
            {
                method: 'DELETE'
            },
            sharedData
        );
    }
}
